var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not_found__box"},[_c('h1',[_vm._v("Хуудас олдсонгүй!")]),_c('p',[_c('router-link',{staticClass:"not_found__no_decoration",attrs:{"to":{ name: 'home' }}},[_vm._v("Нүүр хуудсанд очих?")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }